import { PaymentPlansApi } from '../../../../api/Purchase/PaymentPlans'
import PaymentPlan from '../../../../components/Purchasing/Order/PaymentsPlan/PaymentPlan'
import React from 'react'
import useModalData from '../../../../elements/Hooks/useModalData'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { isEmpty, pick } from 'lodash'
import { message } from 'antd'

PaymentPlanCont.propTypes = {}

function PaymentPlanCont (props) {
  const { owner, isUpdatable } = props
  const { fetching, fetch, list } = useFetchList(
    () => PaymentPlansApi.list(owner._id),
    [owner._id],
    isEmpty(owner._id),
  )
  const {
    isNew,
    visible,
    checkForm,
    modalType,
    remove,
    removing,
    submitting,
    formRef,
    onShow,
    onCancel,
    object: paymentPlan,
    update,
    setSubmitting,
  } = useModalData(PaymentPlansApi.create, PaymentPlansApi.update, PaymentPlansApi.remove, fetch)

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await PaymentPlansApi.create({
        ...newObject,
        order: pick(owner, ['_id', '_key', 'code', 'type', 'title', 'category']),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <PaymentPlan
      {...{
        isNew,
        visible,
        checkForm,
        modalType,
        remove,
        removing,
        submitting,
        submit,
        formRef,
        onShow,
        onCancel,
        paymentPlan,
        update,
        fetching,
        fetch,
        list,
        isUpdatable,
        owner,
      }}
    />
  )
}

export default PaymentPlanCont
